import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
export function PriceBlock() {
  return <section id="price-block" className="bg-kitchen-brown py-14 md:py-24 px-5 md:px-12 lg:px-24 text-center" data-id="element-98">
      <div className="max-w-3xl mx-auto" data-id="element-99">
        <FadeIn data-id="element-100">
          <div className="bg-white rounded-2xl md:rounded-3xl p-6 md:p-12 shadow-2xl relative" data-id="element-101">
            {/* Ribbon */}
            <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-kitchen-terracotta text-white font-bold font-nunito py-2 px-5 md:px-6 rounded-full shadow-lg whitespace-nowrap text-sm md:text-base" data-id="element-102">
              OFERTA ESPECIAL HOY
            </div>

            <h2 className="font-lora text-2xl md:text-4xl font-bold text-kitchen-brown mb-4 md:mb-6 mt-4" data-id="element-103">
              Adquiere hoy "El Método Lunchera Vecinal" por un pago único de
              solo
            </h2>

            <div className="flex items-center justify-center gap-3 md:gap-4 mb-5 md:mb-8" data-id="element-104">
              <span className="text-2xl md:text-4xl font-bold text-kitchen-brown/40 line-through font-lora" data-id="element-105">
                $15.99
              </span>
              <span className="text-5xl md:text-7xl font-bold text-kitchen-green font-lora" data-id="element-106">
                $6.39
              </span>
              <span className="text-xl md:text-2xl text-kitchen-brown/50 font-bold" data-id="element-107">
                USD
              </span>
            </div>
            <div className="inline-block bg-kitchen-terracotta/10 text-kitchen-terracotta font-bold font-nunito text-sm md:text-base px-4 py-1.5 rounded-full mb-5 md:mb-8" data-id="element-108">
              🔥 60% DE DESCUENTO — Solo por hoy
            </div>

            <p className="font-nunito text-base md:text-xl text-kitchen-brown/80 mb-6 md:mb-10 max-w-xl mx-auto" data-id="element-109">
              Menos de lo que cuesta una salida rápida al súper, pero con el
              poder de llenar tu nevera todos los días del mes.
            </p>

            <Button href="https://mujercashflow.com/cart/46609698128062:1" className="w-full max-w-xl text-lg md:text-xl py-4 md:py-5 mb-3 md:mb-4 shadow-kitchen-green/30 shadow-xl" data-id="element-110">
              👉 ¡SÍ, QUIERO EMPEZAR MI NEGOCIO HOY!
            </Button>

            <p className="font-nunito text-xs md:text-base text-kitchen-brown/60 mt-3 md:mt-4" data-id="element-111">
              Haz clic aquí para descargar tu guía y generar efectivo en las
              próximas 48 horas
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}